module.exports = __webpack_public_path__ + "media/images/shared/delivery/cap-3ae30ab0ed94dde992ff7ee4da0a00c4.jpg";